import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, AlertDescription, AlertIcon, AlertTitle, Box } from '@abb/uikit';
import React from 'react';
import { useTranslation } from 'react-i18next';
export function ErrorAlert() {
    const { t } = useTranslation('common');
    return /*#__PURE__*/ _jsxs(Alert, {
        status: "error",
        variant: "left-accent",
        mt: "48px",
        backgroundColor: "red.50",
        borderRadius: "6px",
        children: [
            /*#__PURE__*/ _jsx(AlertIcon, {}),
            /*#__PURE__*/ _jsxs(Box, {
                flex: "1",
                children: [
                    /*#__PURE__*/ _jsx(AlertTitle, {
                        children: t('account.attention')
                    }),
                    /*#__PURE__*/ _jsx(AlertDescription, {
                        display: "block",
                        children: t('errors.permissionError')
                    })
                ]
            })
        ]
    });
}
